// src/services/advisorService.js
import { apiRequest } from "./apiService";

const encId = (id) => encodeURIComponent(String(id == null ? "" : id));

/** Normalize any ID-like field. Do not strip "@". */
const normalizeId = (value) => String(value == null ? "" : value).trim();

/** Normalize optional social handles/usernames. */
const normalizeHandle = (value) =>
  String(value == null ? "" : value).trim().replace(/^@/, "");

const requireObjectPayload = (payload, label) => {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    throw new Error(`Valid payload is required for ${label}.`);
  }
};

const requireCampaignId = (campaignId) => {
  if (campaignId == null || String(campaignId).trim() === "") {
    throw new Error("campaignId is required.");
  }
};

/**
 * POST /advisor/influencer
 * Body: AdvisorInfluencerRequest
 */
export const getAdvisorInfluencer = (payload) => {
  requireObjectPayload(payload, "advisor influencer");

  if (!payload.influencerId) {
    throw new Error("influencerId is required.");
  }

  if (!payload.objective) {
    throw new Error("objective is required.");
  }

  const body = {
    ...payload,
    influencerId: normalizeId(payload.influencerId),
    ...(payload.username != null && payload.username !== ""
      ? { username: normalizeHandle(payload.username) }
      : {}),
  };

  return apiRequest("/advisor/influencer", "POST", body);
};

/**
 * POST /advisor/compare
 * Body: AdvisorCompareRequest
 */
export const getAdvisorCompare = (payload) => {
  requireObjectPayload(payload, "advisor compare");

  if (!Array.isArray(payload.influencerIds) || payload.influencerIds.length < 1) {
    throw new Error("influencerIds[] is required.");
  }

  if (payload.influencerIds.length > 3) {
    throw new Error("influencerIds[] max is 3.");
  }

  if (!payload.objective) {
    throw new Error("objective is required.");
  }

  const influencerIds = payload.influencerIds
    .map(normalizeId)
    .filter(Boolean)
    .slice(0, 3);

  const body = {
    ...payload,
    influencerIds,
    ...(payload.username != null && payload.username !== ""
      ? { username: normalizeHandle(payload.username) }
      : {}),
  };

  return apiRequest("/advisor/compare", "POST", body);
};

/**
 * POST /campaigns/{campaignId}/advisor/brief
 */
export const createCampaignAdvisorBrief = (campaignId, payload) => {
  requireCampaignId(campaignId);
  requireObjectPayload(payload, "campaign advisor brief");

  if (!payload.source) {
    throw new Error("source is required.");
  }

  if (!payload.objective) {
    throw new Error("objective is required.");
  }

  return apiRequest(
    `/campaigns/${encId(campaignId)}/advisor/brief`,
    "POST",
    payload
  );
};

/**
 * GET /campaigns/{campaignId}/advisor/brief
 */
export const getLatestCampaignAdvisorBrief = (campaignId) => {
  requireCampaignId(campaignId);

  return apiRequest(`/campaigns/${encId(campaignId)}/advisor/brief`, "GET");
};